import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload';

import { AppService } from '../../_services/app.service';
import { TWADialogsService } from '../../_services/twa-dialogs.service';
import { ServerConn } from '../../_services/serverConn.service';

@Component({
    selector: 'app-dialog-upload',
    templateUrl: './dialog-upload.component.html',
    styleUrls: ['./dialog-upload.component.css'],
    standalone: false
})
export class DialogUploadComponent implements OnInit {

  public uploader: FileUploader;
  public uploading = false;
  public idcomunidad = 0;
  public comunidades: any[] = [];

  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;

  constructor(
    private dialogRef: MatDialogRef<DialogUploadComponent>,
    private appSvc: AppService,
    private server: ServerConn,
    private snackBar: MatSnackBar,
    private dlgsSvc: TWADialogsService,
  ) {
    this.uploader = new FileUploader({
      url: this.server.serverUrl + 'comunidades/' +
            this.idcomunidad + '/import?api_key=' + localStorage.getItem('api_key')});
  }

  ngOnInit() {
    this.comunidades = this.appSvc.comunidades;
  }

  setComm(ev) {
    console.log('🚀 ~ file: dialog-upload.component.ts ~ line 34 ~ DialogUploadComponent ~ setComm ~ ev', ev);
    this.idcomunidad = ev.value;
  }

  upload() {
    this.uploader.options.url = this.server.serverUrl + 'comunidades/' +
                                this.idcomunidad + '/import?api_key=' + localStorage.getItem('api_key');
    this.uploader.onBeforeUploadItem = (item: any) => {
    };
    this.uploader.queue.forEach((item, idx) => {
      this.uploader.queue[idx].url = this.uploader.options.url;
    });
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      console.log('🚀 ~ file: dialog-upload.component.ts ~ line 51 ~ DialogUploadComponent ~ this.uploader.onCompleteItem ~ response', response);
      this.uploading = false;
      if (typeof response.isError !== 'undefined' && response.isError) {
        this.snackBar.open(
          'Se ha producido un error al importar las solicitudes',
          'Cerrar',
          {
            duration: 10000
          });
      } else {
        if (typeof response.updated === 'undefined') {
          if (typeof response.json !== 'undefined') {
            response = response.json();
          } else {
            try {
              response = JSON.parse(response);
            } catch (error) {
              console.log('🚀 ~ file: dialog-upload.component.ts ~ line 66 ~ DialogUploadComponent ~ this.uploader.onCompleteItem ~ error', error);
            }
          }
        }
        // this.snackBar.open('Se han importado ' + response.data.ctr + ' solicitudes y ' + response.data.ctd + ' crotales.', 'Cerrar', {
        //   duration: 10000
        // });
        let msg = 'Se han importado ' + response.data.ctr + ' solicitudes y ' + response.data.ctd + ' crotales.';
        if (response.data.cte) {
          msg += ' ' + response.data.cte + ' solicitudes ya existían.';
        }
        this.dialogRef.close();
        this.dlgsSvc.confirm(
          'Importación finalizada',
          msg
        ).subscribe((res: any) => {});
      }
    };
    this.uploading = true;
    this.uploader.uploadAll();
  }

  fileChanged(ev): void {
    this.queueFiles();
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

  queueFiles() {
      let i: number,
          l: number,
          item: any;
      for (i = 0, l = this.uploader.queue.length; i < l; i++) {
          item = this.uploader.queue[i];
          if (!item.isUploaded && !item.isUploading && !item.isError) {
              console.log(item);
              item.upload();
          }
      }
  }

}
